export default __webpack_public_path__ + "static/media/loop.b473e349.svg";